import { CheckCircle, Circle, PlayCircle } from 'lucide-react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'

interface Lesson {
  id: string
  title: string
  completed?: boolean
}

interface LessonSidebarProps {
  lessons: Lesson[]
  currentIndex: number
  onSelect: (index: number) => void
  courseTitle?: string
}

export function LessonSidebar({
  lessons,
  currentIndex,
  onSelect,
  courseTitle,
}: LessonSidebarProps) {
  return (
    <div className="w-64 border-r bg-gray-50">
      {courseTitle && (
        <div className="border-b p-4">
          <h3 className="font-semibold text-sm">{courseTitle}</h3>
        </div>
      )}
      <ScrollArea className="h-[calc(100%-56px)]">
        <div className="p-2">
          {lessons.map((lesson, index) => (
            <button
              key={lesson.id}
              onClick={() => onSelect(index)}
              className={cn(
                'flex w-full items-center gap-2 rounded-lg p-3 text-left text-sm transition-colors',
                index === currentIndex ? 'bg-emerald-100 text-emerald-900' : 'hover:bg-gray-100',
              )}
            >
              {lesson.completed ? (
                <CheckCircle className="h-4 w-4 shrink-0 text-emerald-600" />
              ) : index === currentIndex ? (
                <PlayCircle className="h-4 w-4 shrink-0 text-emerald-600" />
              ) : (
                <Circle className="h-4 w-4 shrink-0 text-gray-400" />
              )}
              <span className="line-clamp-2">{lesson.title}</span>
            </button>
          ))}
        </div>
      </ScrollArea>
    </div>
  )
}
